<template>
  <section class="random_box">
    <span v-for="(item,index) in randomCode" :key="index">{{item}}</span>
  </section>
</template>
<script>
export default {
  name: 'keyboard',
  props: {
    randomCode: {
      type:String,
      default:''
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.random_box{
  .flex();
  justify-content: center;
  span{
    width:112px;
    height:136px;
    background:linear-gradient(360deg,rgba(240,241,243,1) 0%,rgba(255,255,255,1) 100%);
    border-radius:8px;
    border:2px solid rgba(234,234,234,1);
    .flex();
    justify-content: center;
    align-items: center;
    font-size:60px;
    color:rgba(23,64,218,1);
    margin:0 14px;
  }
}
</style>
